import { Map } from 'immutable';
import { IGrantee } from '@opengov/reporting-types';
import React, { useMemo } from 'react';
import { OgGridTable } from '@opengov/components-og-grid-table';
import type { ColDef } from 'ag-grid-community';
import { GranteeCellRenderer } from '../ReportGranteeCellRenderer';
import { SelectCellRenderer } from './SelectCellRenderer';

const accessAgGridOptions = {
  components: {
    GranteeCellRenderer: GranteeCellRenderer,
    SelectCellRenderer: SelectCellRenderer<IGrantee>
  },
  defaultColDef: {
    resizable: true,
    suppressHeaderMenuButton: true
  }
};

export interface IReportAccessGridProps {
  granteeRows: Map<string, IGrantee>;
  columnDefs: ColDef[];
}

export const ReportAccessGrid = (props: IReportAccessGridProps) => {
  const { granteeRows, columnDefs } = props;
  const rowData = useMemo(() => Array.from(granteeRows.values()), [granteeRows]);

  return (
    <OgGridTable
      condensed={true}
      gridContainerStyle={{ height: '250px' }}
      rowData={rowData}
      columnDefs={columnDefs}
      gridOptions={accessAgGridOptions}
    />
  );
};
